import {
  Button,
  DatePicker,
  Form,
  Input,
  Radio,
  Upload,
  UploadFile,
} from 'antd';
import { IAddNewChildType } from '../..';
import { PlusOutlined } from '@ant-design/icons';
import styles from './EditChildInfoForm.module.scss';
import { childListResponse } from 'src/core/repo/child/types';
import dayjs from 'dayjs';

interface Props {
  onFinish: (values: IAddNewChildType) => void;
  onFinishFailed: (errorInfo: any) => void;
  setFileList: (fileList: UploadFile[]) => void;
  fileList: UploadFile[];
  selectedChild?: childListResponse | null;
}

const EditChildInfoForm = ({
  fileList,
  onFinish,
  onFinishFailed,
  setFileList,
  selectedChild,
}: Props) => {
  // helper برای DatePicker
  const getDayjsValue = (date?: string) => {
    try {
      return date ? dayjs(date) : undefined;
    } catch {
      return undefined;
    }
  };

  return (
    <Form
      name="childForm"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      style={{ maxWidth: 600 }}
      onFinish={(values: IAddNewChildType) => {
        onFinish(values);
      }}
      onFinishFailed={onFinishFailed}
      labelAlign="left"
      requiredMark={false}
      className={styles.formWrapper}
      autoComplete="off"
      initialValues={{
        childName: selectedChild?.ChildName || '',
        gender: selectedChild?.GenderID?.toString() || '',
        birthDate: getDayjsValue(selectedChild?.BirthDate),
        photo: fileList,
      }}>
      <Form.Item<IAddNewChildType>
        label="Name"
        name="childName"
        className={styles.formItem}
        rules={[{ required: true, message: 'Please enter a name' }]}>
        <Input className={styles.childInput} />
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Birth date"
        name="birthDate"
        className={styles.formItem}
        rules={[{ required: true, message: 'Please select birth date' }]}>
        <DatePicker className={styles.childInput} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Gender"
        name="gender"
        rules={[{ required: true, message: 'Please select a gender' }]}>
        <Radio.Group>
          <Radio value="4">Boy</Radio>
          <Radio value="5">Girl</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item<IAddNewChildType>
        label="Photo"
        name="photo"
        rules={[{ required: false, message: 'Please select a Photo' }]}
        valuePropName="fileList"
        getValueFromEvent={(e) => e && e.fileList}>
        <Upload
          maxCount={1}
          listType="picture-card"
          className={styles.uploader}
          beforeUpload={() => false}
          multiple={false}
          accept="image/*"
          fileList={fileList}
          onChange={({ fileList }) => setFileList(fileList)}>
          {fileList.length >= 1 ? null : (
            <div>
              <PlusOutlined />
            </div>
          )}
        </Upload>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
        <Button
          className={styles.submit_button}
          block
          type="primary"
          htmlType="submit">
          Save Changes
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EditChildInfoForm;
